import { MrvDataTypeEnum } from './AolEnums';

export class MrvData {
    mrvDataRequired?: boolean;
    type: MrvDataTypeEnum;
    eventDateTimeUtc?: string;
    eventDateTimeLocalTime?: string;
    anchoringHours: number;
    observedDistance: number;
    mainEngineConsumptionHfo: number;
    mainEngineConsumptionMgo: number;
    auxiliaryEngineConsumptionHfo: number;
    auxiliaryEngineConsumptionMgo: number;
    boilersConsumptionHfo: number;
    boilersConsumptionMgo: number;
    dieselDrivenPowerpacksConsumptionMgo: number;
    boilersConsumptionForCargoHeatingHfo: number;
    boilersConsumptionForCargoHeatingMgo: number;
    eospUtc?: string;
    sospUtc?: string;
    durationInHours: number;
    localTimeOffsetInHours: number;

    constructor(
        type: MrvDataTypeEnum,
        anchoringHours: number,
        observedDistance: number,
        mainEngineConsumptionHfo: number,
        mainEngineConsumptionMgo: number,
        auxiliaryEngineConsumptionHfo: number,
        auxiliaryEngineConsumptionMgo: number,
        boilersConsumptionHfo: number,
        boilersConsumptionMgo: number,
        dieselDrivenPowerpacksConsumptionMgo: number,
        boilersConsumptionForCargoHeatingHfo: number,
        boilersConsumptionForCargoHeatingMgo: number,
        durationInHours: number,
        localTimeOffsetInHours: number,
        mrvDataRequired?: boolean,
        eventDateTimeUtc?: string,
        eventDateTimeLocalTime?: string,
        eospUtc?: string,
        sospUtc?: string
    ) {
        this.mrvDataRequired = mrvDataRequired;
        this.type = type;
        this.eventDateTimeUtc = eventDateTimeUtc;
        this.eventDateTimeLocalTime = eventDateTimeLocalTime;
        this.anchoringHours = anchoringHours;
        this.observedDistance = observedDistance;
        this.mainEngineConsumptionHfo = mainEngineConsumptionHfo;
        this.mainEngineConsumptionMgo = mainEngineConsumptionMgo;
        this.auxiliaryEngineConsumptionHfo = auxiliaryEngineConsumptionHfo;
        this.auxiliaryEngineConsumptionMgo = auxiliaryEngineConsumptionMgo;
        this.boilersConsumptionHfo = boilersConsumptionHfo;
        this.boilersConsumptionMgo = boilersConsumptionMgo;
        this.dieselDrivenPowerpacksConsumptionMgo = dieselDrivenPowerpacksConsumptionMgo;
        this.boilersConsumptionForCargoHeatingHfo = boilersConsumptionForCargoHeatingHfo;
        this.boilersConsumptionForCargoHeatingMgo = boilersConsumptionForCargoHeatingMgo;
        this.eospUtc = eospUtc;
        this.sospUtc = sospUtc;
        this.durationInHours = durationInHours;
        this.localTimeOffsetInHours = localTimeOffsetInHours;
    }
}
